import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";
import { getConversations } from "../api/chatService";

const POLL_INTERVAL_MS = 30000;

const MessagesContext = createContext(null);

export function MessagesProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [conversations, setConversations] = useState([]);

  const refresh = useCallback(() => {
    if (!isAuthenticated) {
      setConversations([]);
      return Promise.resolve();
    }
    return getConversations()
      .then(setConversations)
      .catch(() => {});
  }, [isAuthenticated]);

  useEffect(() => {
    refresh();
    if (!isAuthenticated) return;
    const interval = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [isAuthenticated, refresh]);

  const unreadCount = conversations.reduce((sum, c) => sum + c.unreadCount, 0);

  const value = { conversations, unreadCount, refresh };

  return <MessagesContext.Provider value={value}>{children}</MessagesContext.Provider>;
}

export function useMessages() {
  const context = useContext(MessagesContext);
  if (!context) {
    throw new Error("useMessages must be used within a MessagesProvider");
  }
  return context;
}
